import { render, staticRenderFns } from "./recent-diet.vue?vue&type=template&id=675906cc&scoped=true&"
import script from "./recent-diet.vue?vue&type=script&lang=js&"
export * from "./recent-diet.vue?vue&type=script&lang=js&"
import style0 from "./recent-diet.vue?vue&type=style&index=0&id=675906cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675906cc",
  null
  
)

export default component.exports